
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"212","height":"424"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M189.3 424H24.7C12.2 424 2 413.8 2 401.3V22.7C2 10.2 12.2 0 24.7 0h164.7C201.8 0 212 10.2 212 22.7v378.7c0 12.4-10.2 22.6-22.7 22.6zM24.7 2C13.3 2 4 11.3 4 22.7v378.7c0 11.4 9.3 20.7 20.7 20.7h164.7c11.4 0 20.7-9.3 20.7-20.7V22.7C210 11.3 200.7 2 189.3 2H24.7zM0 49h2v18H0zM0 82h2v27H0zM0 116h2v27H0z"}}),_c('path',{attrs:{"d":"M119 30H93c-1.7 0-3-1.3-3-3s1.3-3 3-3h26c1.7 0 3 1.3 3 3s-1.3 3-3 3zm-26-4c-.6 0-1 .4-1 1s.4 1 1 1h26c.6 0 1-.4 1-1s-.4-1-1-1H93zM77 31c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM106 17c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM107 414c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15zm0-28c-7.2 0-13 5.8-13 13s5.8 13 13 13 13-5.8 13-13-5.8-13-13-13z"}}),_c('g',[_c('path',{attrs:{"d":"M15 47h184v326H15z","opacity":".1"}}),_c('path',{attrs:{"d":"M200 374H14V46h186v328zm-184-2h182V48H16v324z"}})]),_c('g',[_c('path',{attrs:{"d":"M16 374l76.1-136m32.8-58.7L199 47","opacity":".1"}}),_c('path',{attrs:{"d":"M16.9 374.5l-1.7-1 76.1-136 1.7 1-76.1 136zm108.9-194.7l-1.7-1 74-132.3 1.7 1-74 132.3z"}})])])
          )
        }
      }
    